export const DASHBOARD_SET_PENDING_FARMS_DATA =
  "DASHBOARD_SET_PENDING_FARMS_DATA";
export const DASHBOARD_SET_LOADER = "DASHBOARD_SET_LOADER";
export const DASHBOARD_SET_NOTIFICATION = "DASHBOARD_SET_NOTIFICATION";
export const DASHBOARD_RESET_NOTIFICATION = "DASHBOARD_RESET_NOTIFICATION";
